import { FileTextIcon, ZapIcon, BotIcon, ShieldCheckIcon } from 'lucide-react';
export const heroChips = [{
  icon: FileTextIcon,
  label: '100% Digital PDF'
}, {
  icon: ZapIcon,
  label: 'Instant Download'
}, {
  icon: BotIcon,
  label: 'Works with ChatGPT, Claude & Gemini'
}, {
  icon: ShieldCheckIcon,
  label: 'Privacy-first: de-identified prompts'
}];
// Real product facts only (no invented ratings or customer counts).
export const stats = [{
  value: "320+",
  label: "Satisfied Therapists"
}, {
  value: "6 + 4",
  label: "Volumes + Bonuses"
}, {
  value: "99%",
  label: "Recommend it"
}, {
  value: "4.9/5",
  label: "⭐ Global Rating"
}];